import PropertiesTable from './PropertiesTable';
export default PropertiesTable;
